import React, {useEffect, useState, ReactElement} from 'react';
import Table from 'src/components/SimpleTable';
import ReportDownloadEventsService, {
  ReportDownloadEvent,
} from 'src/services/ReportDownloadEventsService';
import {useBoolean} from '../../../hooks/useBoolean';
import {titleize} from '../../../../shared/utils';

const columns = [
  {
    value: 'User Email',
  },
  {
    value: 'Report Type',
  },
  {
    value: 'Date',
  },
];

interface Props {
  universityId: string;
}

// makes the provided date string more readable
export const formatDate = (date: string): string => {
  const formatted = new Date(Date.parse(date)).toLocaleString();

  // if the provided date is not a valid date string (e.g. null), return the original value
  if (formatted === 'Invalid Date') {
    return date;
  }

  return formatted;
};

const RecentDownloads = ({universityId}: Props): ReactElement => {
  const loading = useBoolean(true);
  const [downloads, setDownloads] = useState<ReportDownloadEvent[]>([]);

  const rows = downloads.map(({userEmail, educationPhase, reportType, createdAt}) => [
    {value: userEmail},
    {value: `${titleize(reportType, true)} - ${titleize(educationPhase, true)}`},
    {value: formatDate(createdAt)},
  ]);

  useEffect(() => {
    ReportDownloadEventsService.index({universityId, limit: 15})
      .then(setDownloads)
      .then(loading.setFalse);
  }, [universityId, loading.setFalse]);

  return (
    <Table caption={<h2 className="shared-font subtitle">Recent Downloads</h2>}>
      <Table.Header columns={columns} />
      <Table.Body
        rows={rows}
        emptyState={{
          numberOfColumns: 3,
          text: loading.value ? 'Loading...' : 'No downloads yet.',
        }}
      />
    </Table>
  );
};

export default RecentDownloads;
